import useCartState from '@order/hooks/useCartState'
import { useMemo } from 'react'

export const usePaymentOrders = (orderIds: string[]) => {
  const savedOrders = useCartState((s) => s.orders)

  return useMemo(
    () => savedOrders.filter((o) => orderIds.includes(o.id)),
    [savedOrders, orderIds]
  )
}
